<div class="wrapper flex flex-col h-full">
  <div class="heading mb-[24px] flex flex-row justify-between items-center">
    <div class="counter text-type-2">
      {{ heading }}
    </div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>

  <div class="details flex flex-col gap-[20px] flex-1 flex-grow">
    @if (note) {
      <div class="text-type-14 unapprove-note">{{ note }}</div>
    }
    @for (field of formFields; track field) {
      @if (field.type === 'signature') {
        <app-text-input
          [controlName]="field.name"
          [label]="field.label"
          [parentFormGroup]="form"
          />
      } @else {
        <app-text-area
          [controlName]="field.name"
          [hideErrorBox]="true"
          [label]="field.label"
          [parentFormGroup]="form"
          class="mb-[20px]"
          />
      }
    }
  </div>

  <div class="actions w-full">
    @if (action?.options?.label === 'Approve') {
      <div class="flex gap-4 justify-center items-center w-full">
        <app-secondary-button (handleClick)="clear()" class="flex-1 w-1/2">Clear</app-secondary-button>
        <app-primary-button (handleClick)="done()" class="flex-1 w-1/2">Sign</app-primary-button>
      </div>
    } @else {
      <app-primary-button (handleClick)="done()" class="flex-1">Done</app-primary-button>
    }
  </div>
</div>
